module.exports = __webpack_public_path__ + "static/chp-web-2-ef2ba528bef86d94e6f9a66103107f5e.jpg";